/**
 * Registers the SoilHaul service worker after the app loads.
 * Kept out of the critical rendering path so it never blocks first paint.
 *
 * The SW is required for Web Push notifications (not just PWA polish), so
 * we register in every environment. In dev this can log a few extra
 * "install/activate" lines but is harmless.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // When a new SW is installed and waiting, activate it immediately so
        // users pick up the latest build on next navigation.
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              registration.waiting?.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {
        // Registration is best-effort; failures shouldn't affect the app.
      });

    // Listen for `NAVIGATE` messages from the SW (fired when a user taps a
    // push notification while a tab is already open).
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "NAVIGATE" && event.data?.url) {
        try {
          window.location.assign(event.data.url);
        } catch {
          // Cross-origin or similar — ignore, user can navigate manually.
        }
      }
    });
  });
}
